import React from 'react';
import { Hero } from './components/Hero';
import { OpeningHook } from './components/OpeningHook';
import { ProblemSection } from './components/ProblemSection';
import { FailedSolutions } from './components/FailedSolutions';
import { UniqueMechanism } from './components/UniqueMechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoIsFor } from './components/WhoIsFor';
import { HowItWorks } from './components/HowItWorks';
import { ProofSection } from './components/ProofSection';
import { FAQ } from './components/FAQ';
import { OfferBlock } from './components/OfferBlock';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream font-sans text-charcoal selection:bg-sage/30 selection:text-charcoal" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <OpeningHook data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <FailedSolutions data-id="element-5" />
        <UniqueMechanism data-id="element-6" />
        <WhatYouGet data-id="element-7" />
        <WhoIsFor data-id="element-8" />
        <HowItWorks data-id="element-9" />
        <ProofSection data-id="element-10" />
        <FAQ data-id="element-11" />
        <OfferBlock data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}